import { IntentTypes } from "@shared/enums";
import { MetacomDataDTO, StoreDetailsDTO } from "./dto.models";

export enum ApiStatus {
  initial = "initial",
  loading = "loading",
  loaded = "loaded",
  error = "error",
}

export interface SelectOption {
  text: string;
  value: string;
  imagePath?: string;
}

export interface Token {
  [prop: string]: any;

  access_token: string;
  token_type?: string;
  expires_in?: number;
  exp?: number;
  refresh_token?: string;
}

export interface QueryParameters {
  storeDetails: StoreDetailsDTO;
  metacomDetails: MetacomDataDTO;
}

export interface SlideInterface {
  url: string;
  title: string;
  subtitle: string;
}

export enum PageState {
  dashboard,
  login,
  other,
}

export interface IntentAndGuid {
  intent: IntentTypes;
  guid: string;
}

export interface MobileAndGuid {
  mobile: string;
  guid: string;
}

export interface EmailAndOtp {
  currentEmail: string;
  currentOtp: string;
}

export interface StateIntegrityCheck {
  currentEmail: string;
  currentOtp: string;
  otpSent: boolean;
  otpMatch: boolean;
}
